import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Vuesax from 'vuesax';
import 'vuesax/dist/vuesax.css';

import App from './App.vue';
import router from './router';
import getMesagges from './i18/messages';

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(Vuesax, {
  colors: {
    dark: 'rgb(36, 33, 69, 0)',
  },
});

const i18nConfig = getMesagges();

const i18n = new VueI18n({
  locale: i18nConfig.language_only,
  messages: i18nConfig.messages,
});

new Vue({
  i18n,
  router,
  render: (h) => h(App),
}).$mount('#app');
